export default __webpack_public_path__ + "locales/hy-AM/ConnectDialog.json?hash=87580201227906515aa6edf8993e4a8c";